export type GuideStep = {
  boldWords?: string[];
  image?: string;
  items?: {
    boldWords?: string[];
    image?: string;
    subSteps?: { boldWords?: string[]; subSteps?: string[]; title: string }[];
    title: string;
  }[];
  title: string;
};

export type GuideProps = {
  description?: string;
  guideTitle: string;
  note?: string;
  steps: GuideStep[];
  tips?: { title: string }[];
};

export enum ModifyGuideTab {
  IMPORT_GRANTS = 'import-grants',
  IMPORT_SAFES = 'import-safes',
  IMPORT_STAKEHOLDERS = 'import-stakeholders',
  MODIFY_STAKEHOLDERS = 'modify-stakeholders',
  STAKEHOLDERS_TERMINATION = 'stakeholders-termination',
  TEMPLATE_PREPARATION = 'template-preparation',
}
